/**
 * @file
 *
 * Make responsive iframes in articles.
 */

const $responsiveVideo = $(
  '.field-name-body iframe, .field-name-field-par-html iframe',
  context
);
$responsiveVideo.once('responsive-iframe').each((index, el) => {
  const $this = $(el);
  if (!$this.parent().hasClass('iframe-responsive')) {
    $this.wrap('<div class="iframe-responsive"></div>');
  }
});
